import React, { Component } from 'react';
import Page from '../containers/page';
import { Waypoint } from 'react-waypoint';

import { Container, Row, Col } from 'reactstrap';
import Article from '../components/article';
import { getSearchParams, generateSearchLink } from '../helpers/linkHelper';
import backyardBanner from '../assets/images/backyard-banner.png';
import backyardLogo from '../assets/images/backyard-logo.png';

class BackyardPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            products: [],
            categoryChain: [],
            pageSize: 24,
            pages: [],
            loadingProducts: true,
            _loading: true,
        };
    }

    get = () => {
        this.setState({ _loading: true }, () => {
            for (let i = 0; i < this.props.loadData.length; i++) {
                this.props.loadData[i](
                    window.fetch,
                    this.props.lang,
                    this.props[0].match,
                ).then((data) => {
                    this.setState({ ...data });
                });
            }

            const params = getSearchParams(this.props[0].location.search, {});

            if (this.props.loadDataWithQuery) {
                for (let i = 0; i < this.props.loadDataWithQuery.length; i++) {
                    this.props.loadDataWithQuery[i](
                        window.fetch,
                        this.props.lang,
                        this.props[0].match,
                        params,
                        this.props[0].location.pathname,
                    ).then((data) => {
                        let stateObj = { ...data };

                        if (data && data.products) {
                            const page = data.__page;
                            stateObj.pages = this.state.pages;
                            stateObj.pages[page] = data.products;
                            stateObj._loading = null;
                        }

                        this.setState(stateObj, () => {
                            this.props.setCacheState({ ...this.state });
                            this.props.updateMeta(
                                this.props.generateSeoTags(this.state, this.props.lang),
                            );

                            if (data && data.products) {
                                setTimeout(() => {
                                    this.setState({ loadingProducts: null });
                                }, 2000);
                            }
                        });
                    });
                }
            }

            this.props.updateMeta(
                this.props.generateSeoTags(this.state, this.props.lang),
            );
        });
    };

    componentDidMount() {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);

            const params = getSearchParams(this.props[0].location.search, { page: 0 });

            if (params.page && params.page != 0 && !this.props.cacheState) {
                this.props[0].history.push(
                    this.props[0].location.pathname +
                    generateSearchLink(
                        this.props[0].location.search,
                        { page: 0 },
                        'page',
                        0,
                        false,
                    ),
                );
            }
        }

        if (this.props[0].history.action === 'POP' && this.props.cacheState) {
            this.setState({ ...this.props.cacheState });
        } else {
            this.get();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps[0].location.search !== this.props[0].location.search) {
            const params = getSearchParams(this.props[0].location.search, { page: 0 });

            if (params.page == 0) {
                this.setState({ products: [], pages: [], total: 0 }, () => {
                    this.get();
                });
            } else {
                this.get();
            }
        }
    }

    render() {
        if (!this.props.uData || !this.props.uData.showBackyard) {
            return <Redirect to="/account" />;
        }
        const params = getSearchParams(this.props[0].location.search, { page: 0 });

        const brandDescription = {
            en: `<p><strong>Backyard Lifestyle</strong> – Modern Design. Lasting Comfort. Outdoor Living Redefined.</p>
       <p>Backyard Lifestyle creates modern outdoor furniture where Scandinavian design meets functionality, comfort, and lasting quality. We combine innovative materials with careful craftsmanship to create furniture that is not only beautiful to look at – but also built to last, season after season.</p>
       <p>Backyard Lifestyle is about more than furniture. It's about creating spaces where people gather, relax, and enjoy outdoor living – from quiet mornings to long summer evenings.</p>`,
            sv: `<p><strong>Backyard Lifestyle</strong> – Modern design. Långvarig komfort. Outdoor living i ny tappning.</p>
       <p>Backyard Lifestyle skapar moderna trädgårdsmöbler där skandinavisk design möter funktion, komfort och hållbar kvalitet. Vi kombinerar innovativa material med noggrant hantverk för att skapa möbler som inte bara är vackra att se på – utan också byggda för att hålla, säsong efter säsong.</p>
       <p>Backyard Lifestyle handlar om mer än möbler. Det handlar om att skapa platser där människor samlas, kopplar av och njuter av livet utomhus – från lugna morgnar till långa sommarkvällar.</p>`,
        };
        return (
            <div className="backyard-page">

                <section className="test-brand">
                    <div
                        className="test-content-brand"
                        style={{ backgroundColor: '#4d4c4c' }}
                    >
                        <img
                            alt="Backyard Lifestyle"
                            src={backyardLogo}
                            style={{
                                width: typeof window !== 'undefined' && window.innerWidth < 768 ? '120px' : '160px',
                                marginBottom: '15px'
                            }}
                        />
                        <div
                            dangerouslySetInnerHTML={{
                                __html: brandDescription[this.props.lang] || brandDescription.sv,
                            }}
                            style={{
                                fontSize: '12px',
                                lineHeight: '1.4',
                                overflow: 'hidden',
                            }}
                        />
                    </div>
                    <img
                        src={backyardBanner}
                        alt="Backyard"
                    />
                </section>


                {/* Broj rezultata */}
                <div className="filters">
                    <Container fluid>
                        <div className="filters-content">
                            <div className="filters-right" style={{ marginLeft: 'auto' }}>
                <span>
                  {this.state.total} {'TRÄFFAR'.translate(this.props.lang)}
                </span>
                            </div>
                        </div>
                    </Container>
                </div>

                {/* Grid proizvoda */}
                <section className="articles">
                    <Container fluid>
                        <Row>
                            <Col lg="12">
                                <Row>
                                    {this.state.pages.map((page, pidx) => {
                                        if (page && page.length && pidx <= params.page) {
                                            return page.map((item, idx) => {
                                                // Sakrij cijenu za ne-logged-in korisnike (isto kao ArticlePage)
                                                if (
                                                    typeof window !== 'undefined' &&
                                                    String(localStorage.getItem('guestToken')).indexOf('retrack-') === -1
                                                ) {
                                                    if (!this.props.uData && item.price) {
                                                        item.price = null;
                                                    }
                                                }

                                                return (
                                                    <Col lg="3" key={`${pidx}${idx}${item.sku}`}>
                                                        <Article
                                                            key={`article_${idx}${item.sku}`}
                                                            wishlistDict={this.props.wishlistDict}
                                                            addToWishlist={this.props.addToWishlist}
                                                            pathname={this.props[0].location.pathname}
                                                            uData={this.props.uData}
                                                            lang={this.props.lang}
                                                            {...item}
                                                        />
                                                    </Col>
                                                );
                                            });
                                        }
                                    })}

                                    <Col lg="12">
                                        {/* Infinite scroll trigger */}
                                        {!this.state.loadingProducts &&
                                        this.state.total > 0 &&
                                        (Number(params.page) || 0) + 1 <
                                        Math.ceil(this.state.total / this.state.pageSize) ? (
                                            <Waypoint
                                                onEnter={() => {
                                                    this.setState({ loadingProducts: true }, () => {
                                                        let currPage = Number(params.page) || 0;
                                                        currPage++;
                                                        if (currPage > this.state.total / this.state.pageSize) {
                                                            currPage = Math.ceil(
                                                                this.state.total / this.state.pageSize,
                                                            );
                                                        }
                                                        this.props[0].history.push(
                                                            this.props[0].location.pathname +
                                                            generateSearchLink(
                                                                this.props[0].location.search,
                                                                { page: 0 },
                                                                'page',
                                                                currPage,
                                                                false,
                                                            ),
                                                        );
                                                    });
                                                }}
                                            />
                                        ) : null}

                                        {/* Spinner */}
                                        <div className="spinner-wrapper">
                                            {this.state.loadingProducts ? (
                                                <div className="lds-spinner">
                                                    <div></div><div></div><div></div><div></div>
                                                    <div></div><div></div><div></div><div></div>
                                                    <div></div><div></div><div></div><div></div>
                                                </div>
                                            ) : null}
                                        </div>
                                    </Col>

                                    {/* Scroll to top */}
                                    <button
                                        className="scroll-top"
                                        onClick={() => window.scrollTo(0, 0)}
                                    >
                                        {'TOPP'.translate(this.props.lang)}
                                    </button>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </div>
        );
    }
}

export default Page(BackyardPage);
